import { useAuthStore } from "PFApp/stores/auth_store";

type UseIsSignedInReturn = {
  isSignedIn: boolean;
};

export const useIsSignedIn = (): UseIsSignedInReturn => {
  const isSignedIn = useAuthStore((state) => !!state.accessToken);

  return {
    isSignedIn
  };
};
